import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Parameter } from "domain/entities/parameter";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { Toast } from "primereact/toast";
import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputDateComponent from "presentation/components/Shared/InputDateComponent";
import { useEmployeesByFilter } from "presentation/hooks/use-query-employees";
import { EmployeeInputFilter } from "domain/models/employee-input-filter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { useProjectMemberUploadStore } from "presentation/stores/use-project-member-upload-store";
import { useCurrentProjectMemberStore } from "presentation/stores/use-current-project-member-store";

interface ParamProps {
  isDisable: boolean;
  onClose?: () => void;
}

const TeamInfoForm: React.FC<ParamProps> = (params: ParamProps) => {
  const toast = useRef<Toast>(null);

  const { email: userEmployeeEmail, userPermissions } = useAuthStore();

  const [employees, setEmployees] = useState<Parameter[]>();
  const { projectRole, projectMemberStatus } =
    useParameterStore();
  const { currentProjectMember, setCurrentProjectMember } =
    useCurrentProjectMemberStore();
  const { projectMembersUpload, setProjectMembersUpload } =
    useProjectMemberUploadStore();

  const { data: employeesData, refetch: refetchEmployees } = useEmployeesByFilter({ limit: 100, isActive: true } as EmployeeInputFilter);

  useEffect(() => {
      const formatedEmployees = employeesData?.data?.map((item) => {
        const employee: Parameter = {
          id: item.id,
          value: item.name,
          type: "projectMember",
        };
  
        return employee;
      });
      setEmployees(formatedEmployees);
    }, [employeesData]);
  

  const handleClick = async () => {
    if (currentProjectMember) {
      if (!currentProjectMember.id) currentProjectMember.id = "Temp_" + crypto.randomUUID();

      // ALTERAR PARA INATIVO QUANDO WORKERS DE MUDANCA DE ESTADO ESTIVEREM IMPLEMENTADOS
      // if(currentProjectMember.id.includes("Temp")) currentProjectMember.status = "Inativo";
      if(currentProjectMember.id.includes("Temp")) currentProjectMember.status = "Ativo";

      if (currentProjectMember.employee) {
        const employee = employees?.find(
          (item) => item.id === currentProjectMember.employee?.id
        );
        currentProjectMember.employee.name = employee?.value || "";
      }

      if (!currentProjectMember.id.includes("Temp")) {
        const updatedList = projectMembersUpload
          .filter((item) => item.id !== currentProjectMember.id)
          .concat(currentProjectMember);

        setProjectMembersUpload(updatedList);
        if (params.onClose) {
          params.onClose();
        }
      } else {
        setProjectMembersUpload([...projectMembersUpload, currentProjectMember]);
      }

      toast.current?.show({
        severity: "info",
        summary: "Informação",
        detail: "Colaborador adicionado.",
        life: 1500,
      });

      setCurrentProjectMember(undefined);
    }
  };

  return (
    <div>

      <div className="default-grid header-spacing">
        
        <div className="default-4-cols">
          <DropdownComponent
            options={employees ?? []}
            label="Colaborador"
            isValueId={true}
            fieldName="employee"
            currentObject={currentProjectMember}
            getValue={currentProjectMember?.employee?.id}
            setValue={setCurrentProjectMember}
            isDisable={!!currentProjectMember?.id}
          />
        </div>
        <div className="default-1-col">
          <DropdownComponent
            options={projectRole}
            label="Função"
            fieldName="projectRole"
            currentObject={currentProjectMember}
            getValue={currentProjectMember?.projectRole}
            setValue={setCurrentProjectMember}
            isDisable={!!currentProjectMember?.id}
          />
        </div>
        <div className="default-1-col">
          <InputDateComponent
            label="Data de início"
            fieldName="startAt"
            currentObject={currentProjectMember}
            getValue={currentProjectMember?.startAt}
            setValue={setCurrentProjectMember}
          />
        </div>
        <div className="default-1-col">
          <InputDateComponent
            label="Data de término"
            fieldName="endAt"
            currentObject={currentProjectMember}
            getValue={currentProjectMember?.endAt}
            setValue={setCurrentProjectMember}
          />
        </div>
        {/* <div className="default-1-col">
          <DropdownComponent
            options={projectMemberStatus}
            label="Status"
            fieldName="status"
            currentObject={currentProjectMember}
            getValue={currentProjectMember?.status}
            setValue={setCurrentProjectMember}
          />
        </div> */}

        <div className="default-4-cols">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {currentProjectMember?.id && (
              <Button label="Atualizar" onClick={handleClick} />
            )}
            {!currentProjectMember?.id && (
              <Button 
                label="Adicionar" 
                onClick={handleClick} 
                disabled={!currentProjectMember?.employee?.id || !currentProjectMember?.projectRole || !currentProjectMember?.startAt}
              />
            )}
          </div>
        </div>

      </div>

      <Toast ref={toast} position="bottom-right" />

    </div>
  );
};
export default TeamInfoForm;
